import { ApiBaseService } from '@/services/ApiBase.service'
import { Document, DocumentsGroupPagedResult, DocumentSummary } from '@/classes/generated-models'

export class DocumentService extends ApiBaseService<Document, DocumentsGroupPagedResult> {
  readonly apiController = 'documents'

  async getSummary(): Promise<DocumentSummary[]> {
    return this.get('summary')
  }
}
